// Copyright 2026. WebPros International GmbH. All rights reserved.

export const TABLE_ACTIONS = {
    VISIBILITY: 'visibility',
    DEFAULT: 'default',
};
